import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ProductCard = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    padding: 24px 16px 20px 24px;
    box-shadow: 0px 0px 6px #00000029;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    margin: 0 5px;
    ${media.mobileDevice`
        /* max-width: 352px; */
        width: 100%;
        margin: 0;
    `}
`;
export const RowDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
export const SetCount = styled.div`
    color: #000000;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
`;
export const Type = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
`;

export const SelectedDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${({ width }) => (width ? width : '250px')};
    ${media.mobileDevice`
    width: ${({ width }) => (width ? width : '246px')};
    `}
`;

export const SelectedCurrentLoc = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'nowrap')};
     word-wrap:  ${({ breakWord }) => (breakWord ? breakWord : 'normal')};
     overflow-wrap: ${({ overflowWrap }) => (overflowWrap ? overflowWrap : 'normal')};
    ${media.mobileDevice`
        /* width: ${({ mbWidth }) => (mbWidth ? mbWidth : '60%')}; */
    `}
`;

export const Parked = styled.div`
    color: #008d00;
    font-family: 'AvenirNextWorld Demi';
    font-size: 10px;
    border: 0.5px solid #00610099;
    background: #cbffd2;
    width: auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 17px;
    height: 18px;
    padding: 3px;
    float: right;
`;

export const AlertIcon = styled.img`
    margin: 3px 5px 0 0;
`;

export const ProductErrorText = styled.div`
    display: flex;
    margin-top: 5px;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    color: #ed002a;
`;

export const TransferSurgeryErrorDiv = styled.div`
    margin: 1px 5px 10px 0;
`;
export const TransferSurgeryErrorTitlerDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
export const TransferSurgeryRedText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: ${({ color }) =>
        color ? color : 'red'};
    line-height: ${({ lineHeight }) => lineHeight};
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;
export const TransferSurgeryBlackText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: ${({ color }) =>
        color ? color : 'black'};
    margin: ${({ margin }) => (margin ? margin : '0')};
    line-height: ${({ lineHeight }) => lineHeight};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;
